<template>
  <MediaObject
    v-if="theme.main_menu_header_media"
    :mediaId="theme.main_menu_header_media"
    class="header-media"
  />
  <div v-else class="headerBox">
    <div v-if="showCustomerLogo" class="whiteCircle">
      <div id="menuHeaderLogo"></div>
    </div>
    <div v-else class="whiteCircle">
      <div class="menuHeaderTitle">{{ $t("menu.header.headline") }}</div>
      <div class="menuHeaderText">{{ siteSetting.customer_name }}</div>
    </div>
    <div
      class="yellowCircle circleGradient"
      id="yellowCircle"
      ref="yellowCircle"
    ></div>
    <div
      class="headerBurger"
      :class="{
        'header-bg': !headerimage
      }"
      :style="{
        'background-image': 'url(' + headerimage + ')'
      }"
    ></div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { isBackgroundImageSet } from "@/utils/helpers";
import MediaObject from "@/components/MediaObject.vue";

export default {
  components: { MediaObject },
  computed: {
    ...mapGetters({
      currentCategory: "CURRENT_CATEGORY",
      siteSetting: "SITE_SETTING",
      theme: "THEME"
    }),
    showCustomerLogo() {
      return isBackgroundImageSet("--component_HeaderMenu_logo_background");
    },
    headerimage() {
      if (!this.currentCategory) return "";
      let header_image = this.currentCategory.header_image;
      if (header_image) {
        return '"' + window.encodeURI(this.currentCategory.header_image) + '"';
      } else {
        return "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.header-media {
  width: 100%;
  height: 260px;
  overflow: hidden;

  ::v-deep img {
    height: 260px;
    object-fit: cover;
  }
}

.headerBox {
  height: 350px;
}

.headerBurger {
  width: 539px;
  height: 427px;
  background-size: contain;
  position: absolute;
  z-index: 4;
  top: 20px;
  left: 541px;
  background-repeat: no-repeat;
}

#menuHeaderLogo {
  background: var(--component_HeaderMenu_logo_background);
  margin-left: var(--component_HeaderMenu_logo_margin-left);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  height: 350px;
  width: 430px;
}

.whiteCircle {
  height: 1170px;
  width: 1170px;
  border-radius: 50%;
  position: absolute;
  background: var(--component_HeaderMenu_whiteCircle_background);
  top: -581px;
  left: -584px;
  padding-top: 350px;
  padding-left: 650px;
  z-index: 2;
  display: flex;
  justify-content: center;
  flex-direction: column;
  pointer-events: none;
}
.yellowCircle {
  width: 652px;
  height: 629px;
  position: absolute;
  border-radius: 50%;
  top: -332px;
  left: 463px;
  z-index: 3;
}

.circleGradient {
  background: var(--component_HeaderMenu_circleGradient_background);
}

.headerTitle {
  color: #f39a00;
  font-size: 40px;
}
.headerText {
  font-size: 40px;
  color: #252525;
}
</style>
